module.exports = __webpack_public_path__ + "img/ledgy.ec38faab.png";